export default __webpack_public_path__ + "static/media/cloudfront.692f6a64.svg";